import { useEffect, useState } from "react";

interface UseSheetAnimationOptions {
  open: boolean;
}

interface UseSheetAnimationReturn {
  isVisible: boolean;
  isAnimating: boolean;
}

/**
 * Custom hook to manage sheet open/close animation states
 * Handles visibility and animation timing for smooth transitions
 */
export const useSheetAnimation = ({
  open,
}: UseSheetAnimationOptions): UseSheetAnimationReturn => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (open) {
      setIsVisible(true);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setIsAnimating(true);
        });
      });
    } else {
      setIsAnimating(false);
      // Wait for animation to complete before hiding
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [open]);

  return {
    isVisible,
    isAnimating,
  };
};
